import * as apiConstant from './api-constant'
import eventPlaza from './event-plaza'
import proctor from './proctor'

export default {
  ...apiConstant,
  ...eventPlaza,
  ...proctor
}



// WEBPACK FOOTER //
// ./src/assets/api/common/index.js